import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import { loadGalleryImages } from 'components/common/BannerImg/GalleryModal/loadGalleryImages';

import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

type DeleteUserLoadedImage = (id: number) => AppThunkAction<void>;

export const deleteUserLoadedImage: DeleteUserLoadedImage = (id) => {
    return (dispatch) => {
        void fetcher
            .delete(`/api/v1/images?id=${id}`)
            .then(() => {
                dispatch(loadGalleryImages());
            })
            .catch(() => {
                addMagritteNotification(MagritteNotificationName.SomethingWentWrong);
            });
    };
};
